/* globals gapi */

export default {
  data() {
    return {
      CLIENT_ID: config.VUE_APP_GOOGLE_CALENDAR_CLIENT_ID
        ? config.VUE_APP_GOOGLE_CALENDAR_CLIENT_ID
        : process.env.VUE_APP_GOOGLE_CALENDAR_CLIENT_ID,
      GoogleApiLoaded: false,
      auth2: {}, // The Sign-In object.
      googleUser: {}, // The current user.
    }
  },

  mounted() {
    if (!this.GoogleApiLoaded) {
      let promise = this.loadGoogleApi()
      this.$uiBlocker(promise)
      promise.then(() => {
        this.GoogleApiLoaded = true
        this.$nextTick(this.configureGoogleApi)
      })
    } else {
      this.GoogleApiLoaded = true
      this.$nextTick(this.configureGoogleApi)
    }
  },

  methods: {
    loadGoogleApi() {
      return new Promise(resolve => {
        let api = document.createElement('script')
        api.onload = resolve
        api.setAttribute('src', 'https://apis.google.com/js/api.js')
        document.head.appendChild(api)
      })
    },
    configureGoogleApi() {
      this.handleClientLoad()
    },
    handleClientLoad() {
      let self = this
      gapi.load('auth2', function() {
        self.auth2 = gapi.auth2.init({
          client_id: self.CLIENT_ID,
          scope: 'profile',
        })
        self.googleUser = self.auth2.currentUser.get()
      })
    },
    appendPre(message) {
      var pre = document.getElementById('content')
      var textContent = document.createTextNode(message + '\n')
      if (pre) pre.appendChild(textContent)
    },
    clearPre() {
      var pre = document.getElementById('content')
      if (pre) pre.innerHTML = ''
    },
  },
}
